import React, { FC, HTMLProps, useEffect, useRef, useState } from 'react';
import { useWindowSize } from '../../hooks/useWindowSize';
import cls from 'classnames';

export const SwipableContainer: FC<HTMLProps<HTMLDivElement>> = ({ className, children, ...props }) => {
  const [hasOverflown, setHasOverflown] = useState(false);
  const [width] = useWindowSize();

  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current) {
      setHasOverflown(ref.current.offsetWidth < ref.current.scrollWidth);
    }
  }, [ref.current, width]);

  return (
    <div ref={ref} className={cls(className, { hasOverflown })} {...props}>
      {children}
    </div>
  );
};
